<script setup>
import { defineProps } from 'vue'

// Define the props
const props = defineProps({
  url: {
    type: String,
    required: true
  }
});
</script>

<template>
  <router-link
      :to="props.url"
      class="p-3 m-2 transition-all bg-white shadow-sm hover:shadow-lg hover:bg-gray-50 rounded-lg fixed top-16 hover:top-15 z-30 flex items-center justify-center space-x-2 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700">
    <span class="material-icons-outlined">arrow_back_ios</span>
    <span>Back</span>
  </router-link>
</template>

<style scoped>

</style>